export default {
    state: {
        set userMsg(obj) {
            const { nickName, userName } = obj.userInfo
            const user = { userName: nickName ? nickName : userName }
            localStorage.setItem('userMsg', JSON.stringify(user))
        },
        get userMsg() {
            const userMsg = localStorage.getItem('userMsg');
            return userMsg ? JSON.parse(userMsg) : {}
        },
        roles: [],
    },
    mutations: {
        setUserMsg(state, userMsg) {
            state.userMsg = userMsg
        },
        SET_ROLES: (state, roles) => {
            state.roles = roles
        },
    }

}